import { render, staticRenderFns } from "./InvitationsNav.vue?vue&type=template&id=53a0ec22&"
import script from "./InvitationsNav.vue?vue&type=script&lang=js&"
export * from "./InvitationsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports